import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react"

import {AB_TESTS, CAMPAIGNS, isTokenExpired} from "../../components/Utils/CommonUtils";

import {useMsal} from "@azure/msal-react";
import {configs, getDomainAlias} from "../../constants";
import {withAuthRetry} from "../auth/tokenRefresh";

//
// const { createProxyMiddleware } = require('http-proxy-middleware');
//
// module.exports = function(app) {
//     app.use(
//         '/api',
//         createProxyMiddleware({
//             target: '//localhost:3000',
//             changeOrigin: true,
//         })
//     );
// };

const dynamicBaseQuery = async (args, api, extraOptions) => {
    const urlEnd = typeof args === 'string' ? args : args.url
    // construct a dynamically generated portion of the url
    let adjustedUrl = ''

    let env = '';
    let baseUrl = 'https://cross-campaign.stage.belka-games.com/campaign'
    if(args.hasOwnProperty('env') && ['production','local','staging'].indexOf(args.env)!==-1) {
        env = args.env
    }

    if(env==='production') {
        if (extraOptions?.type === AB_TESTS) {
            baseUrl = configs[getDomainAlias()].abTestProdUrl
        } else {
            baseUrl = configs[getDomainAlias()].prodUrl
        }
    } else {
        if (extraOptions?.type === AB_TESTS) {
            baseUrl = configs[getDomainAlias()].abTestUrl
        } else {
            baseUrl = configs[getDomainAlias()].baseUrl
        }
    }

    adjustedUrl = baseUrl + urlEnd

    const adjustedArgs =
        typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl }

    try {
        // при 401 токен обновляется (один запрос на всех) и запрос повторяется один раз
        return await authRetryBaseQuery(adjustedArgs, api, extraOptions)
    } catch (error) {
        console.error("Error during query:", error);
        throw error;
    }
}

const dynamicBaseQueryCalendar = () => {
    let baseUrl = 'https://calendar.stage.belka-games.com/api'
    let baseUrlTmp  = configs[getDomainAlias()].calendarUrl;
    if (baseUrlTmp) {
        baseUrl = baseUrlTmp;
    }
    return fetchBaseQuery({ baseUrl: baseUrl })
}

const api = createApi({
    reducerPath: 'api',
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
})

export const calendarApi = createApi({
    reducerPath: 'calendarApi',
    baseQuery: dynamicBaseQueryCalendar(),
    endpoints: () => ({}),
})


const getIdToken = async () => {

    let accessToken = localStorage.getItem("azureToken")
    if(!accessToken || isTokenExpired(accessToken)) {

        //
        // const response = await msalInstance.acquireTokenSilent({
        //     account: account
        // });
        // accessToken = response.accessToken;
    }

    return accessToken
}

const rawBaseQuery = fetchBaseQuery({
    prepareHeaders: async (headers) => {
        const token = localStorage.getItem("azureToken")
        if (token) headers.set("Authorization", `Bearer ${token}`)
        return headers
    }
})

const authRetryBaseQuery = withAuthRetry(rawBaseQuery, localStorage)

export default api
